module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/cooking/knife-fork-2-548251a504a851cfc658752dc5913aaa.svg";